import React, { FC, useCallback, useMemo, useState } from 'react';
import { Setting, Settings } from '../../../scripts/settings';


export const SettingsContext = React.createContext<Setting[]>([])

export const _settingsUpdater = {
    update: () => { }
}

const SettingsLoader: FC = (props) => {
    const { children } = props

    const [settingsId, setSettingsId] = useState<number>(0)


    _settingsUpdater.update = useCallback(() => {
        setSettingsId(settingsId + 1)
    }, [settingsId])


    const settings = useMemo(() => {
        if (settingsId === 2000) {
            console.log("You're updating your settings a lot, huh?")
        }
        return Settings.getSettings();
    }, [settingsId])

    return <SettingsContext.Provider value={settings}>
        {children}
    </SettingsContext.Provider>
}

export default SettingsLoader;